// eslint-disable-next-line
import {
  deleteFacility,
  getFacilitiesByCompany,
  getAllFacilities,
  deleteDetector,
  deleteLocation,
} from '@/api/index';
import { Mixin } from 'mc-js-lib';

export default {
  namespaced: true,
  state() {
    return ({
      facilities: [],
      locations: [],
      detectors: [],
      facilitySelected: {},
      locationSelected: {},
      detectorSelected: {},
      loadingFacilities: false,
    });
  },
  getters: {

  },
  mutations: {
    setFacilities(state, facilitiesList) {
      state.facilities = facilitiesList;
      setTimeout(() => { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setLocations(state, locationList) {
      state.locations = locationList;
      setTimeout(() => { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setDetectors(state, detectorsList) {
      state.detectors = detectorsList;
      setTimeout(() => { Mixin.methods.G_triggerResizeEven(); }, 10);
    },

    setFacilitySelected(state, facility) {
      if (facility) {
        state.facilitySelected = facility;
      }
    },
    setLocationSelected(state, location) {
      if (location) {
        state.locationSelected = location;
      }
    },
    setDetectorSelected(state, detector) {
      if (detector) {
        state.detectorSelected = detector;
      }
    },
    setLoading(state, status) {
      state.loadingFacilities = status;
    },
  },
  actions: {
    async apiGetFacilitiesByCompany({
      commit,
      state,
      rootState,
    }) {
      const companyId = rootState?.user?.company_id;
      if (!companyId) {
        commit('setLoading', false);
        return;
      }

      commit('setLoading', true);
      await getFacilitiesByCompany(companyId, 1, 10).then((res) => {
        if (res.facilities) {
          commit('setFacilities', res.facilities.filter((facility) => !facility.deleted));
          if (state.facilities.length) {
            commit('setFacilitySelected', state.facilities[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiGetAllFacilities({
      commit,
      state,
    }) {
      commit('setLoading', true);
      await getAllFacilities({ page: 1, rows: 100 }).then((res) => {
        if (res.facilities) {
          commit('setFacilities', res.facilities.filter((facility) => !facility.deleted));
          if (state.facilities.length) {
            commit('setFacilitySelected', state.facilities[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiDeleteFacility({
      commit,
      state,
    }) {
      await deleteFacility(state.facilitySelected.facility_id).then((res) => {
        commit('setFacilities', state.facilities.filter((usr) => usr.facility_id !== res.facility_id));
        commit('setFacilitySelected', state.facilities[0]);
      });
    },
    async apiDeleteLocation({
      commit,
      state,
    }) {
      await deleteLocation(state.locationSelected.location_id).then((res) => {
        commit('setLocations', state.locations.filter((usr) => usr.location_id !== res.location_id));
        commit('setLocationSelected', state.locations[0]);
      });
    },

    async apiDeleteDetector({
      commit,
      state,
    }) {
      await deleteDetector(state.detectorSelected.detector_id).then((res) => {
        commit('setDetectors', state.detectors.filter((usr) => usr.detector_id !== res.detector_id));
        commit('setDetectorSelected', state.detectors[0]);
      });
    },

  },
};
